jQuery(document).ready(function($) {
  if (!$('.tabs-vertical').length) {
    return;
  }

  $('.tabs-vertical-main .tabs-vertical-link').click(function(){
		var tab_id = $(this).attr('data-tab');

		$('.tabs-vertical-main .tabs-vertical-link').removeClass('tabs-vertical-link-active');
		$('.tabs-vertical-content').removeClass('tabs-vertical-content-active');

		$(this).addClass('tabs-vertical-link-active');
		$('#'+tab_id).addClass('tabs-vertical-content-active');
	})
});



// WEBPACK FOOTER //
// ./scripts/blocks/tabs-vertical.js